import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { useQueryClient } from '@tanstack/react-query';
import { PatientUploadedMedicalDocument } from '@uplift/api';
import { useCurrentuser } from '@uplift/contexts';
import { Button, Tooltip } from '@uplift/ui-v2';
import { DocumentDeleteModal } from './DocumentDeleteModal.component';


export const UploadedDocumentControls: React.VFC<{
  document: PatientUploadedMedicalDocument;
  onDeleteSuccess: () => Promise<void>;
  pagesLabel?: React.ReactNode;
}> = ({ document, onDeleteSuccess, pagesLabel }) => {
  const me = useCurrentuser();
  const queryClient = useQueryClient();
  const [ isDelete, setIsDelete ] = React.useState<boolean>(false);
  const documentDeletable = me.id === document.providerId;

  return (
    <Box>
      <Divider />
      <Box boxSizing="border-box" p={2} display="flex" justifyContent="space-between" bgcolor="white">
        <Box flex={1}>
          <Tooltip title={documentDeletable ? '' : <span>Only the uploader can<br />delete this document</span>} arrow>
            <Box display="inline-flex">
              <Button
                onClick={async () => {
                  setIsDelete(true);
                }}
                color="error"
                variant="outlined"
                startIcon={<DeleteOutline />}
                disabled={!documentDeletable}
              >Delete</Button>
            </Box>
          </Tooltip>
        </Box>
        <Box display="flex" flex={1} alignItems="center" justifyContent="center">
          {pagesLabel && (
            <Typography variant="body1">{pagesLabel}</Typography>
          )}
        </Box>
        <Box flex={1} />
      </Box>
      <DocumentDeleteModal
        open={isDelete}
        onClose={() => setIsDelete(false)}
        document={document}
        onSuccess={async () => {
          await Promise.all([
            queryClient.invalidateQueries({ queryKey: [ 'user', document.patientId, 'documents' ] }),
            queryClient.invalidateQueries({ queryKey: [ 'user', document.patientId, 'activity' ] }),
          ]);
          setIsDelete(false);
          await onDeleteSuccess();
        }}
      />
    </Box>
  );
};
